import React, { createContext, useState, useEffect, useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { ContextGetData } from '../../services/getData';

const ContextoListaApartamentos = createContext();

const ListaImoveis = ({ children }) => {
  // para o filtro de imóveis

  const [tema, setTema] = useState({});
  const [imovelSelecionado, setImovelSelecionado] = useState('');
  const [selected, setSelected] = useState(false);
  const [meusImoveis, setMeusImoveis] = useState([]);
  const [imovelAtual, setImovelAtual] = useState('');
  const [loadingApartamentList, setLoadingApartamentList] = useState(true);
  // esta variável serve para executar o scroll quando o imóvel for alterado pelas notificações (altera o imóvel e executa o scroll para as fotos)
  const [executarScroll, setExecutarScroll] = useState(null);

  const { Riva, Direcional } = useContext(ThemeContext);

  const { imoveis } = useContext(ContextGetData);

  useEffect(() => {
    if (imovelAtual != '') setTemaAtual(imovelAtual?.tipo);
  }, [imovelAtual]);

  useEffect(() => {
    setSelected(false);
    setImovelAtual('');
    setImovelSelecionado('');
    setLoadingApartamentList(true);
    setTemaAtual(JSON.parse(localStorage.getItem('temaAtual'))?.tipo);
    setLoadingApartamentList(false);
  }, []);

  function setTemaAtual(tipo) {
    if (tipo?.toLowerCase().includes('direcional')) {
      setTema(Direcional);
      localStorage.setItem('temaAtual', JSON.stringify(Direcional));
    } else {
      setTema(Riva);
      localStorage.setItem('temaAtual', JSON.stringify(Riva));
    }
  }

  function setImovelFunction(imovel) {
    setImovelSelecionado(imovel.nome);
    selectApartament(imovel.nome);
    setImovelAtual(imovel);
    setSelected(true);
    setMeusImoveis(imoveis);
    setLoadingApartamentList(false);
  }

  function setImovelNotificacao(assetId) {
    let temp = imoveis.find((imovel) => imovel.assetId == assetId);
    setImovelFunction(temp);
  }

  function selectApartament(nome) {
    setExecutarScroll(null);
    let listaDeApartamentos = Array.from(
      document.getElementsByClassName('itemApartamentList')
    );

    listaDeApartamentos.forEach((apartamento) => {
      apartamento.classList.remove('itemApartamentList--selecionado');
      apartamento.style.color = '';
      if (apartamento.innerHTML == nome) {
        apartamento.classList.add('itemApartamentList--selecionado');
        apartamento.style.color = tema.primaryColor;
      }
    });
  }

  return (
    <ContextoListaApartamentos.Provider
      value={{
        imovelAtual,
        setImovelAtual,
        tema,
        setImovelFunction,
        imovelSelecionado,
        setImovelSelecionado,
        selected,
        setSelected,
        meusImoveis,
        setMeusImoveis,
        selectApartament,
        setImovelNotificacao,
        executarScroll,
        setExecutarScroll,
        loadingApartamentList,
      }}
    >
      {children}
    </ContextoListaApartamentos.Provider>
  );
};

export { ContextoListaApartamentos, ListaImoveis };
